module.exports = __webpack_public_path__ + "img/maduo5.a446d603.jpg";